<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>

    <app-steps #appSteps [steps]="[reportInformationStep, filtersStep]" (onPrimary)="onSave()">
        <!-- Report Information -->
        <app-step
            #reportInformationStep
            [stepForm]="reportInformationForm"
            step="reporting.custom-reports.reportInformation"
            title="reporting.custom-reports.reportInformation"
        >
            <app-custom-report-information
                #reportInformationForm
                [customReportQuery]="customReportQuery"
            ></app-custom-report-information>
        </app-step>

        <!-- Filters -->
        <app-step
            #filtersStep
            [stepForm]="filtersForm"
            step="reporting.custom-reports.filterResults"
            title="reporting.custom-reports.filterResults"
        >
            <app-custom-report-filters
                #filtersForm
                [initalCustomReportFilters]="customReportQuery.filters"
            ></app-custom-report-filters>
        </app-step>
    </app-steps>
</div>
